import { Flex } from '@servicetitan/anvil2';
import { ErrorBoundary } from '@servicetitan/financing-utils-shared';
import { ApplicationDataStore } from '@servicetitan/financing-application-shared';
import {
    FinancingInformationContainer,
    PlansContainer,
    AutoProviderLogo,
    PreApprovalBanner,
} from '@servicetitan/financing-plans-shared';
import { plansPanel, wrapper } from '../workflow/ApplicationWorkflow.module.scss';

interface SelectPlanStepProps {
    onPlanSelected?: () => void;
    // The technician-only "See If I Pre-qualify" (not-me) action. Defaults to onPlanSelected; apps that
    // track pre-approval activity pass a distinct handler so a not-me close isn't logged as a decline.
    onPreQualify?: () => void;
    canChangeProvider?: boolean;
}

export const SelectPlanStep = (props: SelectPlanStepProps) => {
    const { canChangeProvider = false, onPlanSelected, onPreQualify = onPlanSelected } = props;
    const { applicationData } = ApplicationDataStore.useStore();

    const { firstName, lastName } = applicationData.applicant.primaryApplicant ?? {};
    const customerName = [firstName, lastName].filter(Boolean).join(' ') || undefined;

    return (
        <div className={plansPanel} style={{ width: '100%' }}>
            <div className={wrapper}>
                <Flex direction="column" gap="4">
                    <ErrorBoundary actionCausingError="loading available plans">
                        {canChangeProvider ? (
                            <FinancingInformationContainer
                                showProviderSelection
                                amountRangeEnabled
                            />
                        ) : (
                            <>
                                <AutoProviderLogo />
                                <FinancingInformationContainer amountRangeEnabled />
                            </>
                        )}
                        <PreApprovalBanner
                            customerName={customerName}
                            onPreQualify={onPreQualify}
                        />
                        <PlansContainer onPlanSelected={onPlanSelected} amountRangeEnabled />
                    </ErrorBoundary>
                </Flex>
            </div>
        </div>
    );
};
